<template>
  <svg
    v-if="outlined"
    viewBox="-10 -10 178 222"
    fill="transparent"
    stroke="#1F2329"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M74.4347 157.744L9 196.259V39C9 22.4315 22.4315 9 39 9H119C135.569 9 149 22.4315 149 39V196.259L83.5653 157.744L79 155.057L74.4347 157.744Z"
      stroke-width="18"
    />
  </svg>

  <svg v-else viewBox="0 0 158 192" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M74.4347 157.744L9 196.259V39C9 22.4315 22.4315 9 39 9H119C135.569 9 149 22.4315 149 39V196.259L83.5653 157.744L79 155.057L74.4347 157.744Z"
      stroke-width="18"
      class="fill-current"
      :class="colorClass"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps<{
  outlined?: boolean;
  colorClass?: string;
}>();
</script>
